import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import Modal from '../modal';
import { parseSelectedRole } from './../../utilities/user';
import { selectRole, getUserDetails, logout, submitTermsAgreement, getUserProfile } from './../../reducers/identity';
import { setTenant } from '../../reducers/tenants';
import Loader from './../loader';
import RoleSelectorList from './components/roleList';
import RoleSelectorTermsAgreement from './components/termsAgreement';

import './roleSelector.css';

class DisconnectedRoleSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: { open: false },
            agreement: undefined
        };

        this.getModalData = this.getModalData.bind(this);
        this.applyRoleSelection = this.applyRoleSelection.bind(this);
        this.setRoleForAgreement = this.setRoleForAgreement.bind(this);
        this.checkIfRoleSelected = this.checkIfRoleSelected.bind(this);

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    setRoleForAgreement(role) {
        this.setState({ ...this.state, agreement: role });
    }

    applyRoleSelection(role) {
        const { user, impersonatedUser, selectRole, getUserDetails, getUserProfile, setTenant } = this.props;
        const userId = impersonatedUser ? impersonatedUser.id : user.sub;
        getUserDetails(role, () => {
            getUserProfile(userId, () => {
                setTenant(role, () => {
                    selectRole(role);
                });
            });
        });
    }

    getModalData() {
        const { user, roles, logout, submitTermsAgreement } = this.props;
        const { agreement } = this.state;

        if (agreement) {
            return {
                content: (
                    <RoleSelectorTermsAgreement
                        back={() => this.setRoleForAgreement()}
                        onSubmit={() => submitTermsAgreement(user, agreement, result => this.applyRoleSelection(result))}
                    />
                ),
                title: <FormattedMessage id={'chooseRole.TermsAgreement'} defaultMessage={'Terms Agreement'} />
            };
        }

        return {
            content: <RoleSelectorList roles={roles} onRoleSelected={this.applyRoleSelection} logout={logout} showLogout={true} />,
            title:
                roles && roles.length > 0 ? (
                    <FormattedMessage id={'chooseRole.title'} defaultMessage={'Profile selection'} />
                ) : (
                    <FormattedMessage id={'noRoleFound.title'} defaultMessage={'Oh no!'} />
                )
        };
    }

    checkIfRoleSelected() {
        const { role, roles } = this.props;
        if (role) {
            return true;
        }

        if (roles && roles.length === 1) {
            this.applyRoleSelection(roles[0]);
            return true;
        }

        let parsedRole = parseSelectedRole(roles);
        if (parsedRole) {
            this.applyRoleSelection(parsedRole);
            return true;
        }

        return false;
    }

    onOpen() {
        this.setState({ modal: { open: true } });
    }

    onClose() {
        this.setState({ modal: { open: false } });
    }

    componentDidMount() {
        this.onOpen();
    }

    render() {
        let { title, content } = this.getModalData();
        if (this.checkIfRoleSelected()) {
            return <Loader showOverride={true} message={<FormattedMessage {...messages.loadingRoles} />} />;
        }

        return (
            <Modal size="col-xs-12 col-md-6 col-md-offset-3" title={title} open={this.state.modal.open} managedClose onClose={this.onClose}>
                {content}
            </Modal>
        );
    }
}

DisconnectedRoleSelector.defaultProps = {
    roles: []
};

DisconnectedRoleSelector.propTypes = {
    roles: PropTypes.array
};

const mapStateToProps = state => ({
    user: state.identity.user,
    role: state.identity.role,
    roles: state.identity.roles,
    impersonatedUser: state.identity.impersonatedUser
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            selectRole,
            logout,
            getUserDetails,
            getUserProfile,
            submitTermsAgreement,
            setTenant
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectedRoleSelector);



// WEBPACK FOOTER //
// ./src/components/roleSelector/disconnected.jsx